module.exports = __webpack_public_path__ + "img/nn.6ad53928.svg";